import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { useApplicationPageAggregatedData } from "./aggregatedData";
export function useApplicationRequirementEvaluationStatus() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var _aggregatedData$inclu;
        return (_aggregatedData$inclu = aggregatedData.included.find(function (item) {
          return item.type === 'application_requirement_evaluation_status';
        })) === null || _aggregatedData$inclu === void 0 ? void 0 : _aggregatedData$inclu.attributes;
      }
    }),
    data = _useApplicationPageAg.data;
  return {
    applicationRequirementEvaluationStatus: data
  };
}